/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type SetUserSettingsMutationVariables = Types.Exact<{
  settings: Types.Scalars["UserSettings"]["input"];
}>;

export type SetUserSettingsMutation = {
  readonly __typename: "Mutation";
  readonly updateUserSettings: {
    readonly __typename: "User";
    readonly id: c.UserId;
    readonly userSettings: c.PartialUserSettings;
  };
};

export const SetUserSettingsDocument = /*#__PURE__*/ gql`
  mutation setUserSettings($settings: UserSettings!) {
    updateUserSettings(settings: $settings) {
      id
      userSettings
    }
  }
`;
export type SetUserSettingsMutationFn = Apollo.MutationFunction<
  SetUserSettingsMutation,
  SetUserSettingsMutationVariables
>;

/**
 * __useSetUserSettingsMutation__
 *
 * To run a mutation, you first call `useSetUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserSettingsMutation, { data, loading, error }] = useSetUserSettingsMutation({
 *   variables: {
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useSetUserSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetUserSettingsMutation,
    SetUserSettingsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetUserSettingsMutation,
    SetUserSettingsMutationVariables
  >(SetUserSettingsDocument, options);
}
export type SetUserSettingsMutationHookResult = ReturnType<
  typeof useSetUserSettingsMutation
>;
export type SetUserSettingsMutationResult =
  Apollo.MutationResult<SetUserSettingsMutation>;
export type SetUserSettingsMutationOptions = Apollo.BaseMutationOptions<
  SetUserSettingsMutation,
  SetUserSettingsMutationVariables
>;
